var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Component 265 \\u2013 5",
    viewBox: "0 0 15.897 15.897"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4b4b4b",
    d: "M14.762 0H1.132A1.14 1.14 0 0 0 0 1.15v13.6a1.14 1.14 0 0 0 1.132 1.146h13.63A1.143 1.143 0 0 0 15.9 14.75V1.15A1.143 1.143 0 0 0 14.762 0M4.8 13.626H2.449V6.04h2.36v7.587ZM3.627 5.003a1.366 1.366 0 1 1 1.366-1.366 1.367 1.367 0 0 1-1.366 1.366m10.01 8.623h-2.356v-3.69c0-.88-.018-2.012-1.224-2.012-1.228 0-1.416.958-1.416 1.948v3.754H6.284V6.04h2.26v1.036h.032a2.48 2.48 0 0 1 2.233-1.226c2.385 0 2.828 1.572 2.828 3.616Z",
    "data-name": "Icon awesome-linkedin"
  })));
};
export default SvgLinkedin;